import { useMemo } from "react";
import { useGetEntry } from "./patstore";
import { PatstoreNews } from "@types";

const useFindNews = ({
  category,
}: {
  category: string;
}): { news: PatstoreNews[] } => {
  const { entrys: allNews } = useGetEntry();

  const news = useMemo(() => {
    return allNews.filter((news) => news?.categories?.includes(category));
  }, [allNews, category]);

  return { news };
};

export default useFindNews;
